import { render } from "./ComplianceReview.vue?vue&type=template&id=68f5443d"
import script from "./ComplianceReview.vue?vue&type=script&lang=js"
export * from "./ComplianceReview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__